<template>
  <div class="flex flex-col">
    <p class="text-base lg:text-lg px-2 lg:px-3 lg:py-1 text-gray-600 font-medium border-l-4 lg:border-l-8 border-theme-secondary mb-3 lg:mb-6">Source of Funds</p>

    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-2 lg:gap-4">
        <ComboBoxControl label="Select Source of Funds" fieldId="src_fund" v-model="form.src_fund" :required="true" :options="sourceOptions"/>
        <TextControl :maxLength="30" ref="src_others" label="Others (please specify)" fieldId="src_others" v-model="form.src_others"/>
        <TextControl :maxLength="20" ref="src_amount" label="Average Monthly Amount" fieldId="src_amount" :required="true" is_money v-model="form.src_amount"/>
        <TextControl
            :maxLength="30"
            ref="rem1_name"
            label="Remitter's Name 1"
            fieldId="rem1"
            :required="isAllotment"
            v-model="form.rem1_name"
        />

        <TextControl
            :maxLength="30"
            ref="rem1_relationship"
            label="Relationship 1"
            fieldId="rem1_relationship"
            :required="isAllotment"
            v-model="form.rem1_relationship"
        />
        <TextControl :maxLength="30" ref="rem2_name" label="Remitter's Name 2" fieldId="rem2_name" :required="false" v-model="form.rem2_name"/>
        <TextControl :maxLength="30" ref="rem2_relationship" label="Relationship 2" fieldId="rem2_relationship" :required="false" v-model="form.rem2_relationship"/>
        <TextControl :maxLength="30" ref="rem3_name" label="Remitter's Name 3" fieldId="rem3_name" :required="false" v-model="form.rem3_name"/>
        <TextControl :maxLength="30" ref="rem3_relationship" label="Relationship 3" fieldId="rem3_relationship" :required="false" v-model="form.rem3_relationship"/>
    </div>
    
  

    <p class="text-base lg:text-lg px-2 lg:px-3 lg:py-1 text-gray-600 font-medium border-l-4 lg:border-l-8 border-theme-secondary mb-3 lg:mb-6 mt-6 lg:mt-12">US FATCA</p>
    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-2 lg:gap-4">
        <ComboBoxControl label="Are you a U.S. Person?" fieldId="us_citizen" v-model="form.us_citizen" :options="usStatusOptions"/>
        <!-- <ComboBoxControl label="Civil Status" fieldId="civil_status" v-model="form.civil_status" :options="maritalStatusOptions"/>
        <ComboBoxControl label="Gender" fieldId="gender" v-model="form.gender" :options="genderOptions"/>
        <ComboBoxControl label="Select Citizenship" fieldId="citizenship" v-model="form.citizenship" :options="citizenshipOptions"/>
        <TextControl :maxLength="30" ref="us_others" label="Others (please specify)" fieldId="us_others" v-model="form.us_others" /> -->
    </div>

    <p class="text-base lg:text-lg px-2 lg:px-3 lg:py-1 text-gray-600 font-medium border-l-4 lg:border-l-8 border-theme-secondary mb-3 lg:mb-6 mt-6 lg:mt-12">Mother's Maiden Name</p>
    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-2 lg:gap-4">
      <TextControl :maxLength="30" ref="mother_last_name" label="Mother's Maiden Last Name" fieldId="mother_last_name" :required="true" v-model="form.mother_last_name" />
      <TextControl :maxLength="30" ref="mother_first_name" label="Mother's Maiden First Name" fieldId="mother_first_name" :required="true" v-model="form.mother_first_name" />
      <TextControl :maxLength="30" ref="mother_middle_name" label="Mother's Maiden Middle Name" fieldId="mother_middle_name" v-model="form.mother_middle_name" />
    </div>  

    <p class="text-base lg:text-lg px-2 lg:px-3 lg:py-1 text-gray-600 font-medium border-l-4 lg:border-l-8 border-theme-secondary mb-3 lg:mb-6 mt-6 lg:mt-12">Spouse Information</p>
    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-2 lg:gap-4">
        <TextControl :maxLength="30" ref="sp_last_name" label="Spouse's Last Name" fieldId="sp_last_name" v-model="form.sp_last_name"/>
        <TextControl :maxLength="30" ref="sp_first_name" label="Spouse's First Name" fieldId="sp_first_name" v-model="form.sp_first_name"/>
        <TextControl :maxLength="30" ref="sp_middle_name" label="Spouse's Middle Name" fieldId="sp_middle_name" v-model="form.sp_middle_name"/>
        <DatePickerControl label="Spouse's Date of Birth" fieldId="sp_birth_date" v-model="form.sp_birth_date" />
        <TextControl :maxLength="30" ref="sp_occupation" label="Spouse's Occupation" fieldId="sp_occupation" v-model="form.sp_occupation"/>
        
        <div class="flex flex-row items-center justify-start mt-6 lg:mt-12" style="grid-column: span 3 / span 3;">
          <input id="sp_same" type="checkbox" v-model="form.sp_same" class="w-3 h-3 lg:w-6 lg:h-6" style="accent-color: #016b00;">
          <label for="sp_same" class="text-sm lg:text-base ml-2 lg:ml-3">Same as My Present Address</label>
        </div>

        <ComboBoxControl label="Country" fieldId="sp_country" v-model="form.sp_country" :options="countryOptions" @change="onCountryChanged" :disabled="form.sp_same === true" :required="isMarried && !form.sp_same"/>
        
        <template v-if="isPhilippines">
            <ComboBoxControl label="Province" fieldId="sp_province" v-model="form.sp_province" :options="provinceOptions" :disabled="!form.sp_country || form.sp_same" :required="isMarried && !form.sp_same"/>
            <ComboBoxControl label="Municipality" fieldId="sp_municipality" v-model="form.sp_municipality" :options="cityOptions" :is-loading="cityLoading" :disabled="!form.sp_province || form.sp_same" :required="isMarried && !form.sp_same"/>
        </template>
        
        <template v-else>
          <TextControl :max-length="40" label="Province" fieldId="sp_province" v-model="form.sp_province" :disabled="!form.sp_country || form.sp_same" :required="isMarried && !form.sp_same"/>
          <TextControl :max-length="40" label="Municipality" fieldId="sp_municipality" v-model="form.sp_municipality" :disabled="!form.sp_province || form.sp_same" :required="isMarried && !form.sp_same"/>
        </template>
        <TextControl :maxLength="30" ref="sp_brgy" label="Brgy, Subdivision" fieldId="sp_brgy" v-model="form.sp_brgy" :disabled="form.sp_same" :required="isMarried && !form.sp_same"/>
        <TextControl :maxLength="30" ref="sp_street" label="Street" fieldId="sp_street" v-model="form.sp_street" :disabled="form.sp_same" :required="isMarried && !form.sp_same"/>
        <TextControl :maxLength="10" ref="sp_no" label="House No." fieldId="sp_no" v-model="form.sp_no" :disabled="form.sp_same" :required="isMarried && !form.sp_same"/>

        
        <TextControl :maxLength="10" ref="sp_zip_code" label="ZIP Code" fieldId="sp_zip_code" v-model="form.sp_zip_code" is_zip is_num :disabled="form.sp_same" :required="isMarried && !form.sp_same"/>
    </div>

    <p class="text-base lg:text-lg px-2 lg:px-3 lg:py-1 text-gray-600 font-medium border-l-4 lg:border-l-8 border-theme-secondary mb-3 lg:mb-6 mt-6 lg:mt-12">PSO</p>
    <ComboBoxControl label="Choose a PSO that will verify your enrollment" fieldId="branch_code" v-model="form.branch_code" :options="psoOptions" required/>


    <p class="text-grey-darker text-base lg:text-lg font-bold mt-6 lg:mt-12">Are you interested to avail of the products/services below?</p>
    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-2 lg:gap-4 mt-3 lg:mt-6 w-full">
        <div class="flex flex-row items-center justify-start">
          <input id="credit_card" type="checkbox" v-model="credit_card" class="w-4 h-4" style="accent-color: #016b00;">
          <label for="credit_card" class="text-sm lg:text-base ml-1 lg:ml-3">Credit Card</label>
        </div>

        <div class="flex flex-row items-center justify-start">
          <input id="sme_loan" type="checkbox" v-model="sme_loan" class="w-4 h-4" style="accent-color: #016b00;">
          <label for="sme_loan" class="text-sm lg:text-base ml-1 lg:ml-3">SME Loan</label>
        </div>

        <div class="flex flex-row items-center justify-start">
          <input id="internet_banking" type="checkbox" v-model="internet_banking" class="w-4 h-4" style="accent-color: #016b00;">
          <label for="internet_banking" class="text-sm lg:text-base ml-1 lg:ml-3">Internet Banking</label>
        </div>

        <div class="flex flex-row items-center justify-start">
          <input id="mobile_banking" type="checkbox" v-model="mobile_banking" class="w-4 h-4" style="accent-color: #016b00;">
          <label for="mobile_banking" class="text-sm lg:text-base ml-1 lg:ml-3">Mobile Banking</label>
        </div>

        
      </div>

      <div class="mt-8 xl:mt-16 flex flex-row gap-2 lg:gap-4 w-full justify-end">
        <ButtonControl theme="bg-white border-2 border-theme-primary text-theme-primary" rounded button_text="Back"
          @click="$emit('back')" class="w-full lg:w-[20%]"/>
        <ButtonControl theme="bg-primary border-2 border-theme-primary text-white" rounded button_text="Submit"
          @click="confirm_modal = true" :disabled="!isFormComplete" class="w-full lg:w-[20%]" />
      </div>

      <ModalControl v-show="confirm_modal" v-bind:display="confirm_modal" question z_value="z-50"
          @positiveClick="submit" @negativeClick="confirm_modal = false" :positiveButton="'Submit'"
          :negativeButton="'Cancel'" :default_width="'max-w-xl'">
          <div class="w-full px-5 pb-4 flex flex-col text-xl justify-center text-center items-center">
              Fill out the Signature Card and Sign the CIF to complete the process.
          </div>
      </ModalControl>


  </div>
</template>

<script>
import TextControl from '@/components/controls/TextControl.vue';
import DatePickerControl from '@/components/controls/DatePickerControl.vue';
import ComboBoxControl from '@/components/controls/ComboBoxControl.vue';
import ButtonControl from '@/components/controls/ButtonControl.vue';
import ModalControl from '@/components/controls/ModalControl.vue';

import User from '@/services/User';
import mixin from '@/mixin';

export default {
  name: 'v-tab-3',
  inject: ['setLoading'],
  mixins: [mixin],
  data() {
    return {
        confirm_modal: false,
        validationErrors: {},
        cityOptions: [],
        form: {
          // Tab 3 - Source of Funds
          src_fund: '',
          src_others: '',
          src_amount: '',
          rem1_name: '',
          rem1_relationship: '',
          rem2_name: '',
          rem2_relationship: '',
          rem3_name: '',
          rem3_relationship: '',
          
          // US FATCA
          us_citizen: '',
          
          // Mother's Maiden Name
          mother_last_name: '',
          mother_first_name: '',
          mother_middle_name: '',
          
          // Spouse Information
          sp_last_name: '',
          sp_first_name: '',
          sp_middle_name: '',
          sp_birth_date: '',
          sp_occupation: '',
          sp_no: '',
          sp_street: '',
          sp_brgy: '',
          sp_province: '',
          sp_municipality: '',
          sp_country: '',
          sp_zip_code: '',
          sp_same: false,
          
          branch_code: '',
          // Products/Services
          int_products: '0000',
        },
        yesNoOptions: [
            { label: 'YES', value: 1 },
            { label: 'NO', value: 0 }
        ],
    };
  },
  components: {
    TextControl,
    ComboBoxControl,
    DatePickerControl,
    ButtonControl,
    ModalControl
  },
  computed: {
    isMarried() {
      return this.$store.state.formDataPNB.civil_status === 'MARRIED';
    },
    isAllotment() {
        return String(this.form.src_fund || '').trim().toUpperCase() === 'ALLOTMENT';
    },
    isFormComplete() {
        return (
            this.form.src_fund &&
            this.form.src_amount &&

            // Required only when Source of Funds is ALLOTMENT
            (!this.isAllotment || (
                this.form.rem1_name &&
                this.form.rem1_name.trim() &&
                this.form.rem1_relationship &&
                this.form.rem1_relationship.trim()
            )) &&

            this.form.mother_last_name &&
            this.form.mother_first_name &&
            this.form.branch_code
        );
    },
    isPhilippines() {
      return this.form.sp_country === 'PHILIPPINES';
    },
    provinceOptions() {
      const provinces = this.$store.state.provinces;

      if (!Array.isArray(provinces)) return [];

      return provinces.map(p => ({
        label: p.province_name,
        value: p.province_code
      }));
    },
    psoOptions() {
      const pso = this.$store.state.pso;

      if (!Array.isArray(pso)) return [];

      return pso.map(p => ({
        label: p.name,
        value: p.code
      }));
    },
    maritalStatusOptions() {
      const lookup = this.$store.state.lookup;
      if (!lookup || !lookup.marital_status) return [];

      return lookup.marital_status.map(ms => ({
        label: ms,
        value: ms
      }));
    },
    usStatusOptions() {
      const lookup = this.$store.state.lookup;
      if (!lookup || !lookup.are_you_us) return [];

      return lookup.are_you_us.map(us => ({
        label: us.value,
        value: us.key
      }));
    },
    genderOptions() {
      const lookup = this.$store.state.lookup;
      if (!lookup || !lookup.gender) return [];

      return lookup.gender.map(g => ({
        label: g,
        value: g
      }));
    },
    countryOptions() {
      const lookup = this.$store.state.lookup;
      if (!lookup || !lookup.country) return [];

      return lookup.country.map(c => ({
        label: c,
        value: c
      }));
    },
    citizenshipOptions() {
      const nationality = this.$store.state.lookup?.nationality;

      if (!Array.isArray(nationality)) return [];

      return nationality.map(item => ({
        label: item.nationality,
        value: item.nationality
      }));
    },
    sourceOptions() {
      const source = this.$store.state.lookup?.source_of_fund;

      if (!Array.isArray(source)) return [];

      return source.map(item => ({
        label: item,
        value: item
      }));
    },
    credit_card: {
        get() {
          return this.form.int_products?.charAt(0) === '1';
        },
        set(value) {
          this.updateProductBit(0, value);
        }
    },
    sme_loan: {
        get() {
          return this.form.int_products?.charAt(1) === '1';
        },
        set(value) {
          this.updateProductBit(1, value);
        }
    },
    internet_banking: {
        get() {
          return this.form.int_products?.charAt(2) === '1';
        },
        set(value) {
          this.updateProductBit(2, value);
        }
    },
    mobile_banking: {
        get() {
          return this.form.int_products?.charAt(3) === '1';
        },
        set(value) {
          this.updateProductBit(3, value);
        }
    }
  },
  mounted() {
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
    
    this.restoreFormFromStore();
    this.$store.commit('setFormDataPNB', this.form);
  },
  watch: {
    form: {
      deep: true,
      handler(newValue) {
        this.$store.commit('setFormDataPNB', newValue);
      }
    },
    'form.sp_country'(newCountry) {
      if (!newCountry) {
            this.cityOptions = [];
        }
    },
    'form.sp_province'(newProvince) {
      if (newProvince) {
        this.cityLoading = true;

        if (this.form.sp_country == 'PHILIPPINES') {
          User.getCity(newProvince)
            .then((response) => {
              this.cityOptions = response.data.data.map(city => ({
                label: city.city_name,
                value: city.city_code
              }));
              this.cityLoading = false;
            })
            .catch((error) => {
              console.error('Error fetching cities:', error);
              this.cityLoading = false;
            });
        }

      }
    },
    'form.sp_same'(newValue) {
      if (newValue) {
          this.form.sp_no = this.$store.state.formDataPNB.house_no;
          this.form.sp_street = this.$store.state.formDataPNB.street;
          this.form.sp_brgy = this.$store.state.formDataPNB.brgy;
          this.form.sp_province = this.$store.state.formDataPNB.province;
          this.form.sp_municipality = this.$store.state.formDataPNB.municipality;
          this.form.sp_country = this.$store.state.formDataPNB.country;
          this.form.sp_zip_code = this.$store.state.formDataPNB.zip_code;
      } else {
          this.form.sp_no = '';
          this.form.sp_street = '';
          this.form.sp_brgy = '';
          this.form.sp_province = '';
          this.form.sp_municipality = '';
          this.form.sp_country = '';
          this.form.sp_zip_code = '';
      }
    }
  },
  methods: {
    onCountryChanged() {
        this.form.sp_province = "";
        this.form.sp_municipality = "";
        this.form.sp_brgy = "";
        this.cityOptions = [];
    },
    restoreFormFromStore() {
      const storeFormData = this.$store.state.formDataPNB || {};

      Object.keys(this.form).forEach((key) => {
        if (Object.prototype.hasOwnProperty.call(storeFormData, key) && storeFormData[key] !== undefined && storeFormData[key] !== null) {
          this.form[key] = storeFormData[key];
        }
      });
    },
    updateProductBit(index, checked) {
      let bits = (this.form.int_products || '0000')
        .padEnd(4, '0')
        .split('');

      bits[index] = checked ? '1' : '0';

      this.form.int_products = bits.join('');
    },
    submit() {
      this.confirm_modal = false;
      this.setLoading(true);

      this.$emit('submit');
    },
  },
};
</script>

<style scoped>
.papsi-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 2rem;
}
.box {
  width: 4rem !important;
  height: 4rem !important;
  margin-right: 3rem !important; 
}
@media (max-width: 1000px) {
    .box {
      width: 2rem !important;
      height: 2rem !important;
      margin-right: 1rem !important;
      font-size:  5rem !important;
    }
    .agree {
      font-size: 1.7rem !important; 
    }
   

}

</style>